import { questionnaireGql } from '../../data/gql-gen/questionnaire'

// Legacy single-survey duplication. Used for every non-multi-market project
// type; the source's single market collapses onto `newSurveyId`.
export const DUPLICATE_QUESTIONNAIRE_V2 = questionnaireGql(/* GraphQL */ `
  mutation duplicateQuestionnaireV2(
    $projectId: ID!
    $newProjectId: ID!
    $newSurveyId: ID!
    $accountMarkup: Float
  ) {
    duplicateQuestionnaireV2(
      projectId: $projectId
      newProjectId: $newProjectId
      newSurveyId: $newSurveyId
      accountMarkup: $accountMarkup
    ) {
      questionnaireId
      marketIds
      createdDate
      sinceDate
      entries {
        number
        position
        contextPosition
        createdDate
        sinceDate
      }
    }
  }
`)

// Multi-market duplication. `marketMappings` must cover EVERY source market
// (source survey -> its new survey); the backend fails fast otherwise. A
// tracker also passes the wave to copy and the new project's wave.
export const DUPLICATE_MULTI_MARKET_QUESTIONNAIRE_V2 = questionnaireGql(
  /* GraphQL */ `
    mutation duplicateMultiMarketQuestionnaireV2(
      $projectId: ID!
      $newProjectId: ID!
      $marketMappings: [MarketIdMappingInput!]!
      $accountMarkup: Float
      $sourceWaveId: ID
      $newWaveId: ID
    ) {
      duplicateMultiMarketQuestionnaireV2(
        projectId: $projectId
        newProjectId: $newProjectId
        marketMappings: $marketMappings
        accountMarkup: $accountMarkup
        sourceWaveId: $sourceWaveId
        newWaveId: $newWaveId
      ) {
        questionnaireId
        marketIds
        createdDate
        sinceDate
        entries {
          number
          position
          contextPosition
          createdDate
          sinceDate
        }
      }
    }
  `
)
